import React from 'react'
import './bubbles.css'

import img_bubble from './images/bubble.png'

const Bubbles = () => {
    return (
        <div className="aw-bubbles">
            <img src={img_bubble} alt="" />
            <img src={img_bubble} alt="" />
            <img src={img_bubble} alt="" />
            <img src={img_bubble} alt="" />
            <img src={img_bubble} alt="" />
            <img src={img_bubble} alt="" />
            <img src={img_bubble} alt="" />
        </div>
    )
}

export default Bubbles